import axios from "axios"
import logger from "./logService"

axios.interceptors.response.use(null, error => {
	const expectedError = error.response && error.response.status >= 400 && error.response.status < 500

	if (!expectedError) {
		logger.log(error)
		if (error.Error === "Network Error") {
			console.error("Network Error")
		}
	}

	return Promise.reject(error)
})

export function setJwt(jwt) {
	if (typeof window === "object") {
		axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`
	}
}

const getAuthHeader = ()=>{
	const authToken = sessionStorage.getItem("token")
	return {
		headers: {
			common:{
				"Authorization":`Bearer ${authToken}`
			}
		}
	}
}

let http = {
	get: (url,config)=>axios.get(url,{
		...config,
		...getAuthHeader(),
	}),
	post:(url,data,config)=>axios.post(url,data,{
		...config,
		...getAuthHeader(),
	}),
	put: (url,data,config)=>axios.put(url,data,{
		...config,
		...getAuthHeader(),
	}),
	patch: (url,data,config)=>axios.patch(url,data,{
		...config,
		...getAuthHeader(),
	}),
	delete: (url,config)=>axios.delete(url,{
		...config,
		...getAuthHeader(),
	}),
	setJwt
}
export default http
